module.exports = __webpack_public_path__ + "static/green-26486d77d4eb46314e0e14b3d258e88f.jpg";